import * as yup from "yup";
import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useYupValidationResolver } from "../../../hooks/useYupValidationResolver";
import { formatTo } from "../../../utils/dateTimeHelper";

const validationSchema = yup.object({
    forename: yup.string().required("Field is required"),
    surname: yup.string().required("Field is required"),
    dateOfBirth: yup.string().required("Field is required"),
    genderTypeId: yup.string().required("Field is required"),
    yearGroupId: yup.string().required("Field is required"),
    nationality: yup.string().required("Field is required"),
    startDate: yup.string().required("Field is required"),
    relationshipTypeId: yup.string().required("Field is required"),
});

const emptyFields = {
    forename: "",
    surname: "",
    dateOfBirth: "",
    genderTypeId: "",
    yearGroupId: "",
    nationality: "",
    startDate: "",
    relationshipTypeId: "",
};

export const useDetailsForm = (data) => {
    const defaultValues = useMemo(() => ({
        forename: data?.forename || emptyFields.forename,
        surname: data?.surname || emptyFields.surname,
        dateOfBirth: data?.dateOfBirth || emptyFields.dateOfBirth,
        genderTypeId: data?.genderTypeId || emptyFields.genderTypeId,
        yearGroupId: data?.currentNotionalYearGroup || emptyFields.yearGroupId,
        nationality: data?.countryOfResidence || emptyFields.nationality,
        startDate: data?.desiredStartDate || emptyFields.startDate,
        relationshipTypeId: data?.relationshipTypeId || emptyFields.relationshipTypeId,
    }), [data]);

    const resolver = useYupValidationResolver(validationSchema);

    const {
        control,
        handleSubmit,
        register,
        reset,
        watch,
        setValue,
        formState: { errors, isDirty: isDirtyForm, isSubmitted },
    } = useForm({ resolver, defaultValues });

    useEffect(() => {
        reset(defaultValues);
    }, [defaultValues]);

    return {
        control,
        register,
        errors,
        handleSubmit,
        reset,
        watch,
        setValue,
        isDirtyForm,
        isSubmitted,
    };
};
